<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>
<mat-tab-group (selectedTabChange)="tabChange($event)">
  <mat-tab *ngFor="let type of translationsKey;" [label]="type">
    <div>
      <page-content [noPadding]="true">
        <data-table (edit)="onEdit($event)" (detail)="onDetail($event)" [columns]="columns" [plainData]="translations[type]">
        </data-table>
      </page-content>
    </div>
  </mat-tab>

</mat-tab-group>
